import { Dashboard } from './dashboard';

// @todo  Make sure types are set properly
export interface User {
    disabled: boolean | undefined;
    defaultDashboardId: string | null | undefined;
    permissions: {
        role: string | undefined;
        minimumPollDelay: number | undefined;
        filters: {
            operators: string[] | undefined;
            airports: string[] | undefined;
            registrations: string[] | undefined;
        };
        aeroApiKey: string | undefined;
    };
    id: string;
    username: string | undefined;
    avatar: string | undefined;
    email: string | undefined;
    name: string | undefined;
    dashboards: Dashboard[] | undefined;
    admin: { version: string | undefined };
}

export function createUserModel(): User {
    const newUser: User = {
        disabled: false,
        defaultDashboardId: '',
        permissions: {
            role: '',
            minimumPollDelay: 30,
            filters: {
                operators: [],
                airports: [],
                registrations: [],
            },
            aeroApiKey: '',
        },
        id: '',
        username: '',
        avatar: '',
        email: '',
        name: '',
        dashboards: [],
        admin: { version: '' },
    };

    return newUser;
}
